import { Publication } from './publication';

export class Formation extends Publication {

    
    parent;
    categorie;
    chemin;

    constructor() {
        super();
        this.is_publish = true;
    }

    
    
   
  }